import apiClient from "../../../../../utils/clients/axios";

export const getReportIssueDataForMd = async () => {
  const response = await apiClient.get(
    `/api/quality_control/report_issue/notifications`
  );
  return response;
};
